import request from '../../shared/request'

export function getAuditRevisions({ target_id, table }) {
  return request(`/job/audit/${target_id}/${table}`)
}



// WEBPACK FOOTER //
// ./src/redux/api/audit.js